import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { TrainingSlidesVM } from '../setup-training-types.model';
import { TrainingService } from '../training.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-slide',
  templateUrl: './add-slide.component.html',
  styleUrls: ['./add-slide.component.scss']
})
export class AddSlideComponent implements OnInit {
  optionupdate: boolean = false;
  IsLink: boolean = false;
  SlideTypeId: number;
  TrainingId: number;
  SectionId: number;
  isAddSlide: boolean = false;
  slideName: string;
  selectedFile: File;
  SlideImage: string;
  SlideImage_fromPC: string;
  link: string;
  SlideInfo: TrainingSlidesVM;
  isEditSlide: boolean = false;
  constructor(
    public _dialogRef: MatDialogRef<AddSlideComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _notify: NotificationsService,
    private _trainingService: TrainingService,
    private ref: ChangeDetectorRef,
    private _sanitizer: DomSanitizer,
  ) { }



  ngOnInit() {
    this.TrainingId = this.data.TrainingId;
    this.SectionId = this.data.SectionId;
    this.isAddSlide = this.data.isAddSlide;
    this.SlideInfo = this.data.SlideInfo;
    this.isEditSlide = this.data.isEditSlide;

    if (this.isEditSlide == true) {
      console.log("slideInfo___ 111", this.SlideInfo)
      this.slideName = this.SlideInfo.SlideName;
      this.SlideTypeId = this.SlideInfo.SlideTypeId;
      this.SlideImage = this.SlideInfo.SlideImage;
      this.link = this.SlideInfo.YoutubeLink;

    }
  }

  ChangeSlideType() {

  }

  onEditSlide() {
    let s = new TrainingSlidesVM();
    s.SlideName = this.slideName;
    s.SubSectionId = this.SectionId;
    s.TrainingId = this.TrainingId;
    s.SlideTypeId = Number( this.SlideTypeId);
    s.YoutubeLink = this.link;
    s.SlideImage = this.SlideImage;
    s.SlideId=this.SlideInfo.SlideId;
    this._trainingService.UpdateSelectedSlide(s).subscribe(res => {
      if (res == true) {
        this._notify.success('Saved', 'Successfully Update Slide');
        this._dialogRef.close(true)
      } else {
        this._notify.error('Failed', 'Failed to Update Slide');
      }
    })
  }
  onAddSlide() {
    let s = new TrainingSlidesVM();
    s.SlideName = this.slideName;
    s.SubSectionId = this.SectionId;
    s.TrainingId = this.TrainingId;
    s.SlideTypeId = this.SlideTypeId;
    s.YoutubeLink = this.link;
    s.SlideImage = this.SlideImage;
    
    
    this._trainingService.AddNewSlide(s).subscribe(res => {
      if (res == true) {
        this._notify.success('Saved', 'Successfully Add New Slide');
        this._dialogRef.close(true)
      } else {
        this._notify.error('Failed', 'Failed to Add New Slide');
      }
    })
  }

  onNoClick() {
    this.optionupdate = false;
    this._dialogRef.close(false);
  }
  sanitize(image: string) {
    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
  }

  onSelectPhoto(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.selectedFile = event.target.files[0];
      reader.onloadend = (e) => {
        this.uploadPhoto(reader.result as string);

      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  uploadPhoto(newPhoto: string) {
    this.SlideImage_fromPC = newPhoto.split(",")[1];
    this.SlideImage = this.SlideImage_fromPC;


  }
}
